/**
 * Утилиты для форматирования данных
 */

/**
 * Форматирует длительность в формат MM:SS
 * @param {number} value - Длительность в секундах или миллисекундах
 * @returns {string} Отформатированная строка MM:SS
 */
export const formatDuration = (value) => {
  if (!value || value === 0 || isNaN(value)) return '0:00';
  
  let seconds = value;
  
  // Если значение очень большое (> 10000), вероятно это миллисекунды
  if (value > 100000) {
    seconds = Math.floor(value / 1000);
  } else if (value > 10000) {
    seconds = Math.floor(value / 1000);
  } else {
    seconds = Math.floor(value);
  }
  
  // Ограничиваем разумными пределами (максимум 999:59)
  if (seconds < 0) seconds = 0;
  if (seconds > 59999) seconds = 59999;
  
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Нормализует строку для сравнения (убирает лишние пробелы, приводит к нижнему регистру)
 * @param {string} str - Строка для нормализации
 * @returns {string} Нормализованная строка
 */
export const normalizeString = (str) => {
  return (str || '').toLowerCase().trim().replace(/\s+/g, ' ');
};

/**
 * Форматирует процентное значение
 * @param {number} value - Значение от 0 до 1
 * @returns {string} Процентное значение
 */
export const formatPercent = (value) => {
  return `${Math.round((value || 0) * 100)}%`;
};

